import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useDebounce } from 'use-debounce'
import { DecodedValueMap, QueryParamConfigMap } from 'use-query-params'
import { BookingCar } from '~/shared/api'
import { Button } from '~/shared/ui/Buttons'
import { mapFiltersQueryParamsToList } from '~/shared/ui/ScrollableList'
import { ApplyButtonTitle } from './styled'

type ApplyButtonProps = {
  filtersQuery: DecodedValueMap<QueryParamConfigMap>
}

export function ApplyButton({ filtersQuery }: ApplyButtonProps) {
  const filters = useMemo(
    () => mapFiltersQueryParamsToList(filtersQuery),
    [filtersQuery],
  )

  const getCount = async () => {
    let builder = BookingCar.limit(1)

    filters?.forEach(({ key, value }) => {
      builder = builder.where(key, value)
    })

    const response = await builder.get(1)
    const httpClientResponse = response.getHttpClientResponse()
    const axiosResponse = httpClientResponse?.getUnderlying()
    const { total } = axiosResponse?.data?.meta?.page || { total: 0 }
    return total
  }

  const queryKey = useMemo(() => JSON.stringify(filters), [filters])
  const [debounceGridKey] = useDebounce(queryKey, 300)

  const { isFetching, data } = useQuery(
    ['filters-apply-booking-cars-count', debounceGridKey],
    () => getCount(),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
    },
  )

  return (
    <Button type='submit' fullWidth variant='limeFlooded' loading={isFetching}>
      <ApplyButtonTitle>
        <div style={{ marginRight: '6px' }}>Показать</div>

        {!isFetching && <div style={{ minWidth: '16px' }}>{data}</div>}
      </ApplyButtonTitle>
    </Button>
  )
}
